module.exports = __webpack_public_path__ + "fonts/MaterialDesignIcons.ddc7fab.woff";